import React from 'react';

export const TalkPage: React.FC = () => (
  <iframe
    src="/talk.html"
    title="Pixel Machha Talk"
    style={{ width: '100vw', height: '100vh', border: 'none', position: 'fixed', inset: 0, zIndex: 9999 }}
  />
);
